module.exports = __webpack_public_path__ + "img/status-icn_scheduled@3x.95491a31.png";